import type { FaireProductEntity } from "../../entity_types/product";

export const p_5bdj64a8e6: FaireProductEntity = {
  token: "p_5bdj64a8e6",
  type: "product",
  name: "Tepoztlán Candle",
  brandToken: "b_c3hepkjc1t",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.faire.com/fastly/82592f83514f60a0a9eacee303d0059d20863f9d19ac8007295e7902b6d5c267.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd363433c02a906fb6b8d15d7b07e25892ea8f05daece3428fc192d8f1fe8377.jpeg",
    "https://cdn.faire.com/fastly/ce8bc897d95b6481c0262d62ad97512e79dfda700a6b9d7285fd22cb5e30ba7c.jpeg",
    "https://cdn.faire.com/fastly/793366272f569d7adf434f81bee1a7c67b152afeca5767b4868651f795ebcf23.jpeg",
    "https://cdn.faire.com/fastly/7328baf9c4a1ebae0a8e4301435c33c8b82909b4e9a29f95c585a5e1bd40c329.jpeg",
  ],
  priceDollars: 25,
  description:
    "8.5 oz | 241 g\nBurn time: 60 hours\n\nTepoztlán - Located outside of Mexico City, the ancient city of Tepoztlán has long been a center for healing and renewal. Profound scents of copal, patchouli and sandalwood bring awareness to your body and mind in the moment.\n\nTOP: Bonfire Smoke, Cedarwood Essential Oil*, Copal Accord\nMID: Patchouli Essential Oil*, Cade Oil, Eucalyptus\nBASE: Birch Essential Oil*, Guaiac Wood Essential Oil*, Sandalwood\n\nBENEFITS\n • Non-toxic Luxury Fragrance\n • Phthalates Free | Paraffin Free | Palm Oil Free | Vegan\n • Coco-Soy Wax Blend\n • Organic Cotton Wick\n\nOur glass vessels were hand blown by artisans in Mexico City. Be sure to use them for your favorite Margarita or Paloma once you’ve burned through your candle.\n",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:48.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
